import { useEffect, useState } from "react";
import { useLoader } from "../useLoader";
import ApiService from "../../services/ApiServiceClass";

export type supplierType = {
    id: number,
    name: string,
    location: string
}

export const useGetSuppliers = () => {
    const [suppliers, setSuppliers] = useState<supplierType[]>([]);
    const loader = useLoader();

    const fetchSuppliers = async () => {

        loader?.setIsLoading(true);
        try {
            const responseData = await ApiService.getSuppliers();
            setSuppliers(responseData.data);
            loader?.setIsLoading(false);            
        } catch(error) {
            loader?.setIsLoading(false);
            return null;
        }
    }

    useEffect(() => {
        fetchSuppliers();
    }, []);

    return {suppliers, setSuppliers};
}
